<template>
  <div class="recommendations">
    <div class="recommendations__title">Полезное для вас</div>
    <div class="recommendations__row">
      <RecMaterial
        v-for="(item, ind) in NewRecommendations"
        :key="ind"
        :item="item"
        :hideImage="true"
        :hideFavorites="true"
        @recClick="recClick"
      />
    </div>
  </div>
</template>

<script>
import RecMaterial from "@/components/pageComponents/RecMaterial.vue";
import { mapGetters } from "vuex";
export default {
  name: "RecMaterials",
  props: {
    parent: {
      type: Object,
      default: {
        name: "",
        id: "",
        type: ""
      }
    },
  },
  components: {
    RecMaterial,
  },
  computed: {
    ...mapGetters(["NewRecommendations"]),
  },
  methods: {
    recClick(item) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: item.brands.map((el) => el.title).join(", "),
          brand_id: item.brands.map((el) => el.brand_id).join(", "),
          content_id: item.id || '',
          content_name: item.name,
          content_type: item.type,
          nosology_name: item.disease.map((el) => el.title).join(", "),
          content_parameter: "",
          event_type: "click",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.parent.name,
          page_type: this.parent.type,
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recommendations {
  overflow: hidden;
  &__title {
    margin-bottom: 24px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>